module.exports = __webpack_public_path__ + "assets/img/app_down_qrcode.9ad74393.png";